// extracted by mini-css-extract-plugin
module.exports = {"container":"SurveyBuilder_container__2jsrK"};